import { PlaceholderRangeEditorProps } from "../../../../types/bulkEmails/CriteriaOption";
import { DatePicker, Form, Row } from "antd";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../../../lib/constants";
import { useCallback, useMemo } from "react";
import { Rule } from "antd/es/form";

export const DefaultDateRangeCriteria = ({
  value,
  onChange,
  form,
  formKeys,
  placeholders
}: PlaceholderRangeEditorProps) => {
  const [startKey, endKey] = formKeys;

  const normalizedValue = useMemo<[string | null | undefined, string | null | undefined]>(() => {
    if (Array.isArray(value)) {
      return [value[0] ?? null, value[1] ?? null];
    }

    return [null, null];
  }, [value]);

  const startRules = useMemo(() => [{ required: true, message: "Please enter From date" }], []);

  const endRules = useMemo(
    () => [
      {
        validator(_r: Rule, value: undefined | null | string) {
          if (value === null || value === undefined || value === "") {
            return Promise.resolve();
          }

          const startValue = normalizedValue[0];

          if (!startValue) {
            return Promise.reject(new Error("From date must be set before To date"));
          }

          if (startValue && dayjs(value) < dayjs(startValue)) {
            return Promise.reject(new Error("To date must be greater than From date"));
          }

          return Promise.resolve();
        }
      }
    ],
    [normalizedValue]
  );

  const handleStartChange = useCallback(
    (nextValue: any) => {
      if (nextValue) {
        nextValue = dayjs(nextValue).format(DATE_FORMAT);
        onChange([nextValue, normalizedValue[1] || null]);
      } else {
        onChange([null, normalizedValue[1] || null]);
      }
    },
    [normalizedValue, onChange]
  );

  const handleEndChange = useCallback(
    (nextValue: any) => {
      if (nextValue) {
        nextValue = dayjs(nextValue).format(DATE_FORMAT);
        onChange([normalizedValue[0] || null, nextValue || null]);
      } else {
        onChange([normalizedValue[0] || null, null]);
      }
    },
    [onChange, normalizedValue]
  );

  return (
    <Row className="criteria-range align-start w-100">
      <Row className="align-start justify-space-between">
        <span className="text-md title label">{placeholders?.[0]}</span>
        <Form.Item className="mb-0 w-auto" label="" name={startKey} rules={startRules} preserve={false}>
          <DatePicker
            className="input"
            value={dayjs(normalizedValue[0])}
            format={DATE_FORMAT}
            placeholder="MM/DD/YY"
            onChange={handleStartChange}
          />
        </Form.Item>
      </Row>
      <Row className="align-start justify-space-between">
        <span className="text-md title label">{placeholders?.[1]}</span>
        <Form.Item className="mb-0 w-auto" label="" name={endKey} rules={endRules} preserve={false}>
          <DatePicker
            className="input"
            value={dayjs(normalizedValue[1])}
            format={DATE_FORMAT}
            placeholder="MM/DD/YY"
            onChange={handleEndChange}
          />
        </Form.Item>
      </Row>
    </Row>
  );
};
